import { getShareBetDataWithKey } from '@core/Areas/ShareBet/helpers/api'
import { loadBet } from '@core/Areas/ShareBet/LoadBet'
import { trackShareBetLinkOpen } from '@core/Areas/ShareBet/helpers/analytics'
import type { QuickbetSelection } from '@core/Areas/Quickbet/types'

export async function buildSharedBetSelections({
  shareId,
}: {
  shareId: string | null
}): Promise<QuickbetSelection[]> {
  if (!shareId) {
    throw new Error('No Share Provided')
  }

  const { data, accountNumber: origin } = await getShareBetDataWithKey(shareId)

  const { selections } = await loadBet(data, { location: 'share-bet', origin })

  trackShareBetLinkOpen({
    share_origin: origin,
    betType: selections.length === 1 ? 'single' : 'multi',
  })

  return selections
}
